import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import "./EmailLogs.css";

import { getEmailLogsRequest } from "../../../redux/actions/emailActions";

const STATUS_CONFIG = {
    SUCCESS: {
        label: "Succès",
        color: "#166534",
        bg: "#dcfce7",
    },
    FAILED: {
        label: "Échec",
        color: "#b91c1c",
        bg: "#fee2e2",
    },
};

const formatDateTime = (value) => {
    if (!value) return "—";
    try {
        const date = new Date(value);
        return date.toLocaleString("fr-FR");
    } catch {
        return value;
    }
};

const EmailLogs = ({ logs, loading, error, getEmailLogs }) => {
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("ALL");

    useEffect(() => {
        getEmailLogs();
    }, []);

    const filteredLogs = useMemo(() => {
        const term = search.trim().toLowerCase();

        return (logs || []).filter((log) => {
            const matchesSearch =
                !term ||
                (log.recipient || "").toLowerCase().includes(term) ||
                (log.subject || "").toLowerCase().includes(term) ||
                (log.templateCode || "").toLowerCase().includes(term) ||
                (log.errorMessage || "").toLowerCase().includes(term);

            const matchesStatus =
                statusFilter === "ALL" || log.status === statusFilter;

            return matchesSearch && matchesStatus;
        });
    }, [logs, search, statusFilter]);

    return (
        <div className="email-logs-page embedded">
            <div className="email-logs-header compact">
                <div>
                    <h3>Logs des emails</h3>
                    <p>Consultez les emails envoyés, leur statut et les éventuelles erreurs.</p>
                </div>

                <button className="email-logs-refresh-btn" onClick={getEmailLogs} disabled={loading}>
                    {loading ? "Chargement..." : "Actualiser"}
                </button>
            </div>

            <div className="email-logs-toolbar">
                <input
                    type="text"
                    className="email-logs-search"
                    placeholder="Rechercher par destinataire, sujet, template..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <select
                    className="email-logs-filter"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                >
                    <option value="ALL">Tous les statuts</option>
                    <option value="SUCCESS">Succès</option>
                    <option value="FAILED">Échec</option>
                </select>

                <div className="email-logs-count">
                    {filteredLogs.length} résultat{filteredLogs.length > 1 ? "s" : ""}
                </div>
            </div>

            {error && <div className="email-logs-alert error">{error}</div>}

            <div className="email-logs-table-wrapper">
                <table className="email-logs-table">
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>Destinataire</th>
                        <th>Template</th>
                        <th>Sujet</th>
                        <th>Statut</th>
                        <th>Envoyé par</th>
                        <th>Erreur</th>
                    </tr>
                    </thead>

                    <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={7} className="email-logs-empty">
                                Chargement des logs...
                            </td>
                        </tr>
                    ) : filteredLogs.length === 0 ? (
                        <tr>
                            <td colSpan={7} className="email-logs-empty">
                                Aucun log email trouvé
                            </td>
                        </tr>
                    ) : (
                        filteredLogs.map((log) => {
                            const statusCfg = STATUS_CONFIG[log.status] || {
                                label: log.status || "—",
                                color: "#334155",
                                bg: "#e2e8f0",
                            };

                            return (
                                <tr key={log.id}>
                                    <td>{formatDateTime(log.createdAt)}</td>
                                    <td className="email-logs-recipient">{log.recipient || "—"}</td>
                                    <td>
                                            <span className="email-logs-template">
                                                {log.templateCode || "Email libre"}
                                            </span>
                                    </td>
                                    <td className="email-logs-subject">{log.subject || "—"}</td>
                                    <td>
                                            <span
                                                className="email-logs-status"
                                                style={{
                                                    color: statusCfg.color,
                                                    background: statusCfg.bg,
                                                }}
                                            >
                                                {statusCfg.label}
                                            </span>
                                    </td>
                                    <td>{log.createdByName || "—"}</td>
                                    <td className="email-logs-error-cell">
                                        {log.errorMessage ? (
                                            <span className="email-logs-error-text">{log.errorMessage}</span>
                                        ) : (
                                            "—"
                                        )}
                                    </td>
                                </tr>
                            );
                        })
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    logs: state.emails?.logs || [],
    loading: state.emails?.loading || false,
    error: state.emails?.error || null,
});

const mapDispatchToProps = (dispatch) => ({
    getEmailLogs: () => dispatch(getEmailLogsRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailLogs);